import { Controller } from "@hotwired/stimulus"

// Keeps the assistant rail's thread scrolled to its newest bubble
// (TASK-268.1). The thread body is replaced whole by Turbo Streams (by
// class, in both copies of the rail), so the scroll box watches its own
// children and follows the end whenever they change — unless the member has
// scrolled up to re-read, in which case it leaves them where they are.
export default class extends Controller {
  connect() {
    this.atEnd = true
    this.toEnd()
    this.onScroll = () => { this.atEnd = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight < 80 }
    this.element.addEventListener("scroll", this.onScroll, { passive: true })
    this.observer = new MutationObserver(() => { if (this.atEnd) this.toEnd() })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener("scroll", this.onScroll)
  }

  toEnd() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
